export const ageOptions = () => {
  const ageOpts = [];
  for (let i = 3; i <= 25; i++) {
    ageOpts.push(i);
  }
  return ageOpts;
};

export const getClasses = async () => {
  const res = await fetch(
    "https://db.beeola.me/api/collections/grades/records",
    { headers: { accept: "application/json" } }
  );

  const jsonRes = await res.json();
  if (res.ok) {
    return jsonRes.items.map((_class: any) => _class.detail);
  }

  throw jsonRes;
};
